module.exports = __webpack_public_path__ + "static/media/add_filter.58e2bf43.svg";